import React, { FC } from "react"
import styled from "styled-components"

interface ILink {
  to: string
  text: string
}

const links: ILink[] = [
  {
    to: "https://npfsberbanka.ru/ipp/",
    text: "Индивидуальный пенсионный план",
  },
  {
    to: "https://npfsberbanka.ru/ops/",
    text: "Перевести накопления в НПФ",
  },
  {
    to: "https://npfsberbanka.ru/business/",
    text: "Корпоративным клиентам",
  },
  {
    to: "https://npfsberbanka.ru/about/",
    text: "О Фонде",
  },
  {
    to: "https://npfsberbanka.ru/contacts/",
    text: "Контакты",
  },
]

const MobileMenuStyle = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  padding: 64px 20px 16px;
  overflow: auto;
  background: white;

  a {
    display: block;
    padding: 12px 0;
    border-bottom: 1px solid #eaeaea;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #2d3033;
    text-decoration: none;
  }

  .menu-close {
    position: absolute;
    top: 15px;
    right: 13px;
    padding: 10px;
    font-size: 36px;
    line-height: 16px;
    color: #9595a6;
    transform: rotate(45deg);
    cursor: pointer;
  }
`

const MobileMenuClosed = styled.div`
  display: none;
`

interface IMobileMenu {
  isVisible: boolean
  onClose: () => void
}

export const MobileMenu: FC<IMobileMenu> = ({ isVisible, onClose }) => {
  return isVisible ? (
    <MobileMenuStyle>
      <span className="menu-close" onClick={onClose}>
        +
      </span>
      <nav>
        {links.map(({ to, text }, index) => (
          <a href={to} key={index}>
            {text}
          </a>
        ))}
      </nav>
    </MobileMenuStyle>
  ) : (
    <MobileMenuClosed />
  )
}
